export default function Confirmation({ transactionNumber, incidentType, submittedBy, onReset }) {
  return (
    <div className="form-card" style={{ textAlign: "center" }}>
      <div className="confirmation-icon">✓</div>
      <h2 className="card-title">Report Submitted</h2>
      <p className="card-subtitle" style={{ marginBottom: 8 }}>
        Your incident report has been received and logged.
      </p>

      <div className="txn-badge">{transactionNumber}</div>

      <p style={{ fontSize: 14, color: "var(--text-secondary)", marginTop: 8, marginBottom: 4 }}>
        Type: <strong>{incidentType}</strong>
      </p>
      <p style={{ fontSize: 13, color: "var(--text-muted)", marginBottom: 24 }}>
        Submitted by {submittedBy}
      </p>

      <p style={{ fontSize: 13, color: "var(--text-secondary)", marginBottom: 24 }}>
        A confirmation email with a PDF copy of your report has been sent to the Risk Management team.
        Please save your transaction number for reference.
      </p>

      <button className="btn-secondary" onClick={onReset}>
        Submit Another Report
      </button>
    </div>
  );
}
